import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import {
  Dashboard,
  Calendar,
  plus,
  fileicon,
  SendIcon,
  GreenTickCircle,
  Recording,
  Complete,
  CrossCircled,
  bookingIcon,
  RsIcon,
  Setting,
  RightArw,
  Bookings,
  Report,
  Dashboard2Icon,
  anylitics,
  AtmCardIcon,
  Support,
  Headset,
  CrossWhite,
  BookingSidebar,
  Ruppe2,
  CompletedEvent,
  LiveEvent,
  Threeline,
  Chaticon,
  Profile1,
  plusgray,
  Notification,
  Wallet,
  InfluencerIcon,
  PersonGray,
  bed,
  Logo,
  Downarrow2,
  Rightarrow,
} from "../../assests/ExportImageIcon";

import "./sidebar.css";

const EventSidebar = ({ collapsed }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [openMenu, setOpenMenu] = useState(null);

  const handleClick = (name, route = null) => {
    if (route) {
      navigate(route);
    }
  };

  const handleDropdownClick = (name) => {
    if (collapsed) return;

    setOpenMenu((prev) => (prev === name ? null : name));
  };

  const isActive = (name) => {
    switch (name) {
      case "event-dashboard":
        return (
          location.pathname === "/event-dashboard" ||
          location.pathname.startsWith("/event-dashboard/")
        );

      case "all-events":
        return (
          location.pathname === "/all-events" ||
          location.pathname.startsWith("/all-events/") ||
          location.pathname === "/event-detail" ||
          location.pathname.startsWith("/event-detail/")
        );

      case "create-event":
        return (
          location.pathname === "/create-event" ||
          location.pathname.startsWith("/create-event/")
        );

      case "event-booking":
        return (
          location.pathname === "/event-booking" ||
          location.pathname.startsWith("/event-booking-detail")
        );

      case "finance":
        return (
          location.pathname === "/finance" ||
          location.pathname.startsWith("/finance/")
        );

      case "event-settings":
        return (
          location.pathname === "/event-settings" ||
          location.pathname.startsWith("/event-settings/")
        );

      case "support-tickets":
        return (
          location.pathname === "/requests" ||
          location.pathname.startsWith("/requests/")
        );

      default:
        return false;
    }
  };

  const isEventManagementActive =
    location.pathname === "/all-events" ||
    location.pathname.startsWith("/all-events/") ||
    location.pathname === "/event-detail" ||
    location.pathname.startsWith("/event-detail/") ||
    location.pathname === "/create-event" ||
    location.pathname.startsWith("/create-event/");

  const isOpen = (name) => openMenu === name;

  return (
    <div className={`sidebar ${collapsed ? "collapsed" : ""}`}>
      <div onClick={() => navigate("/event-dashboard")} className="logo">
        <img
          src={Logo}
          alt="Travel Booking"
          style={{
            maxHeight: "48px",
            maxWidth: "100%",
            objectFit: "contain",
            cursor: "pointer",
          }}
        />
      </div>

      <ul className="menu">
        <li className="menu-item">
          <div
            className={`menu-link ${
              isActive("event-dashboard") ? "active" : ""
            }`}
            onClick={() => handleClick("event-dashboard", "/event-dashboard")}
          >
            <img src={Dashboard} className="menu-icon-img" alt="" />

            {!collapsed && <span className="menu-text">Dashboard</span>}
          </div>
        </li>

        {/* Event Management */}
        <li className="menu-item showdrpdown">
          <div
            className={`menu-link ${isEventManagementActive ? "active" : ""}`}
            onClick={() => handleDropdownClick("Event Management")}
            style={{ cursor: "pointer" }}
          >
            <img src={Calendar} className="menu-icon-img" alt="" />

            {!collapsed && (
              <>
                <span className="menu-text">Event Management</span>

                <span className="ms-auto">
                  {isOpen("Event Management") ? (
                    <img src={Downarrow2} alt="" />
                  ) : (
                    <img src={Rightarrow} alt="" />
                  )}
                </span>
              </>
            )}
          </div>

          {!collapsed && isOpen("Event Management") && (
            <ul className="submenu">
              <li
                onClick={() => handleClick("all-events", "/all-events")}
                className={isActive("all-events") ? "active" : ""}
              >
                <img src={Threeline} className="menu-icon-img" alt="" />

                <span className="menu-text">All Events</span>
              </li>

              <li
                onClick={() => handleClick("create-event", "/create-event")}
                className={isActive("create-event") ? "active" : ""}
              >
                <img src={plusgray} className="menu-icon-img" alt="" />

                <span className="menu-text">Create Event</span>
              </li>
            </ul>
          )}
        </li>

        <li className="menu-item">
          <div
            className={`menu-link ${isActive("event-booking") ? "active" : ""}`}
            onClick={() => handleClick("event-booking", "/event-booking")}
          >
            <img src={BookingSidebar} className="menu-icon-img" alt="" />

            {!collapsed && <span className="menu-text">Bookings</span>}
          </div>
        </li>

        <li className="menu-item">
          <div
            className={`menu-link ${isActive("finance") ? "active" : ""}`}
            onClick={() => handleClick("finance", "/finance")}
          >
            <img src={Ruppe2} className="menu-icon-img" alt="" />

            {!collapsed && <span className="menu-text">Finance</span>}
          </div>
        </li>

        <li className="menu-item">
          <div
            className={`menu-link ${
              isActive("event-settings") ? "active" : ""
            }`}
            onClick={() => handleClick("event-settings", "/event-settings")}
          >
            <img src={Setting} className="menu-icon-img" alt="" />

            {!collapsed && <span className="menu-text">Settings</span>}
          </div>
        </li>

        <li className="menu-item">
          <div
            className={`menu-link ${
              isActive("support-tickets") ? "active" : ""
            }`}
            onClick={() => handleClick("support-tickets", "/requests")}
          >
            <img src={Headset} className="menu-icon-img" alt="" />

            {!collapsed && <span className="menu-text">Support & Ticket</span>}
          </div>
        </li>
      </ul>
    </div>
  );
};

export default EventSidebar;
